up.compiler('[tags-input]', (element) => {
    Tags.init('#'+element.id, );
});